<script setup lang="ts">
import { useHead } from '#app'
import { useI18n, useLocalePath } from '#i18n'
import { useCountryConfig } from '~/composables/useCountryConfig'

const { t, locale } = useI18n()
const { titleTranslationKey } = useCountryConfig()
const localePath = useLocalePath()
const treeStore = useCategoryTreeStore()

useHead(
  { title: t(titleTranslationKey, { title: t('errors.page.notFound.title') }) },
)

const buttons = computed(() => {
  return treeStore.roots.map(node => ({
    to: localePath(`/c/${treeStore.normalize(node.terms[locale.value] ?? node.terms.de ?? '')}`),
    label: node.terms[locale.value] ?? node.terms.de ?? '',
  }))
})
</script>

<template>
  <v-container class="pa-6 mb-16" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" class="text-center">
        <v-img
          src="/images/404.png"
          alt="404"
          width="400"
          class="mx-auto mt-5"
        />

        <h1 class="text-h2 error-primary mt-8 font-weight-bold">
          {{ $t('errors.page.notFound.title') }}
        </h1>
        <p class="text-subtitle-1 text-medium-emphasis pt-15">
          {{ $t('errors.page.notFound.declaration') }}
        </p>

        <p class="text-body-1 text-medium-emphasis mt-4">
          {{ $t('errors.page.notFound.subtitle2') }}
        </p>

        <v-row justify="center" class="mt-8">
          <v-col v-for="item in buttons" :key="item.to" cols="auto">
            <NuxtLink :to="item.to">
              <v-btn
                color="primary"
                variant="elevated"
                size="large"
                class="px-6"
                rounded
              >
                {{ item.label }}
              </v-btn>
            </NuxtLink>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
.error-code {
  font-size: 120px;
  color: #ff9999;
  line-height: 1;
}

.error-primary {
  color: #dc3545;
}

.v-icon {
  color: #dc3545 !important;
  transform: rotate(90deg);
  font-size: 80px !important;
}
</style>
